import { calculatePageSize } from "../../helpers/utils";
import { apiCall } from "./service";
import {
  URL_USER,
  URL_USERS,
  URL_ROLES,
  URL_CREATE_ROLE,
  URL_UPDATE_ROLE,
  URL_DELETE_ROLE,
  URL_WORKING_HOURS,
  URL_PERMISSIONS,
  URL_UPDATE_PERMISSIONS,
  URL_GROUPS,
  URL_SEARCH_CLIENTS,
  URL_SEARCH_PROGRAM,
  URL_CREATE_NEW_USER,
  URL_SEARCH_USER,
  URL_RESET_USER_PASSWORD,
  URL_SEARCH_ROLE,
  URL_SEARCH_CHANGE_REQUEST,
  URL_SORT_USERS,
  URL_USER_FLAG,
  URL_ROLE_FLAG,
  URL_ROLE_PERMISSIONS,
  URL_LAYOUT_SETTINGS,
  URL_USER_NOTES,
  URL_USER_WORKLOAD,
  URL_UPDATE_USER
} from "./URL";
const Id = localStorage.getItem("id");

export const api = {
  updateUserPasswordRequest(params) {
    return apiCall.put({
      url: `${URL_USERS}${Id}${URL_RESET_USER_PASSWORD}`,
      isAuthToken: true,
      params,
    });
  },

  fetchSingleUserDataRequest(id) {
    return apiCall.get({ url: `${URL_USER}${id}` });
  },

  searchUserDataRequest(searchText) {
    return apiCall.get({ url: `${URL_SEARCH_USER}${searchText}` });
  },

  createNewUserRequest(value) {
    return apiCall.post({
      url: `${URL_CREATE_NEW_USER}`,
      isAuthToken: true,
      params: { name: value },
    });
  },

  searchRoleDataRequest(searchText) {
    return apiCall.get({ url: `${URL_SEARCH_ROLE}${searchText}` });
  },

  searchChangeRequest(searchText) {
    return apiCall.get({ url: `${URL_SEARCH_CHANGE_REQUEST}${searchText}` });
  },

  sortUsersRequest(params) {
    return apiCall.pagination({
      url: `${URL_SORT_USERS}pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`,
      isAuthToken: true,
    });
  },

  updateUserFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_USER_FLAG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  userDataRequest(params) {
    return apiCall.get({
      url: `${URL_USER}${params}`,
      isAuthToken: true,
      params,
    });
  },

  updateUserDataRequest(params) {
    return apiCall.put({
      url: `${URL_USERS}${params.id}`,
      isAuthToken: true,
      params,
    });
  },

  updateUserPictureRequest(params) {
    return apiCall.file({
      url: `${URL_USERS}${params.id}/PFP`,
      params: params,
    });
  },

  updateWrkingHoursRequest(params) {
    return apiCall.put({
      url: `${URL_USERS}${Id}/${URL_WORKING_HOURS}`,
      params: params,
    });
  },

  updatePermissionsRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_PERMISSIONS}${params.id}${URL_PERMISSIONS}`,
      params: { permissions: params.permissions },
    });
  },

  sortRolesRequest(params) {
    return apiCall.pagination({
      url: `${URL_ROLES}pageNumber=${params.page}&pageSize=${params.size}&orderby=${params.orderBy}`,
      isAuthToken: true,
    });
  },

  updateRoleFlagRequest(params) {
    return apiCall.patch({
      url: `${URL_ROLE_FLAG}${params.id}`,
      isAuthToken: true,
      params: params.payload,
    });
  },

  getPermissionsRequest(id) {
    return apiCall.patch({
      url: `${URL_ROLE_PERMISSIONS}${id}`,
      isAuthToken: true,
    });
  },

  rolesRequest(params) {
    const { search, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    
    if (search) {
      paginationParams.searchTerm = search;
    }
  
    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${URL_ROLES}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },

  createRoleRequest(params) {
    return apiCall.post({ url: `${URL_CREATE_ROLE}`, params });
  },

  updateRoleRequest(params) {
    return apiCall.put({
      url: `${URL_UPDATE_ROLE}${params.id}`,
      params: { name: params.name, description: params.description },
    });
  },

  deleteRoleRequest(params) {
    return apiCall.delete({ url: `${URL_DELETE_ROLE}${params.id}` });
  },

  groupsRequest(params) {
    return apiCall.pagination({
      url: `${URL_GROUPS}`,
      isAuthToken: true,
      params,
    });
  },

  searchClientDataRequest(searchText) {
    return apiCall.get({ url: `${URL_SEARCH_CLIENTS}${searchText}` });
  },

  getUserLayoutRequest(name) {
    return apiCall.get({
      url: `${URL_LAYOUT_SETTINGS}?name=${name}`,
      isAuthToken: true,
    });
  },

  putUserLayoutRequest(payload) {
    return apiCall.put({
      url: `${URL_LAYOUT_SETTINGS}`,
      isAuthToken: true,
      params: payload,
    });
  },
  getUserNotes() {
    return apiCall.get({
      url: `${URL_USER_NOTES}`,
      isAuthToken: true,
    });
  },
  updateUserNotes(payload) {
    return apiCall.put({
      url: `${URL_USER_NOTES}`,
      isAuthToken: true,
      params: payload,
    });
  },
  getUserEvents(params) {
    let query = new URLSearchParams(params).toString();
    if(query)
      query = `?${query}`;

    return apiCall.get({
      url: `${URL_USER_WORKLOAD}${query}`,
      isAuthToken: true,
    });
  },
  async updateUserStatus(params) {
      try {
        const response = await apiCall.put({
                                              url: `${URL_UPDATE_USER}${params.id}/Status`,
                                              params: params.payload,
                                            });
        return { 
          success: true, 
          message: 'Resource status updated successfully'
        };
      } catch (error) {
        return { 
          success: false, 
          error: error.response?.data?.error || error.data?.error || 'Failed to update resource status',
          code: error.status };
      }
    },
};

export default api;
